import http from "../http";

export async function searchTrace(data) {
  const response = await http.post("/partner-service/trace-search", data);
  return response.data;
}

export async function callMatchBook(data) {
  const response = await http.post("/directory-service-proxy/entity/search", data);
  return response.data;
}
